@let opened = sidenavOpened$ | async;
  @if (opened) {
    <div class="sidenav-close-button-wrapper">
      <button mat-icon-button mgdButton class="mat-sidenav-close-icon-button" (click)="onSidenavToggleClick()" matTooltip="Close menu">
        <mat-icon>arrow_menu_close</mat-icon>
      </button>
    </div>
  }
  @else {
    <div class="sidenav-open-button-wrapper">
        <button mat-icon-button mgdButton class="mat-sidenav-open-icon-button" (click)="onSidenavToggleClick()" matTooltip="Open menu">
          <mat-icon>arrow_menu_open</mat-icon>
        </button>
      </div>
  }
<div id="scrolling-wrapper" cdkScrollable>
  <mat-sidenav-container class="mat-sidenav-container">
    
    <mat-sidenav mode="side" [opened]="opened" class="mat-sidenav">
      <div class="sidenav-content">
        <div class="sidenav-info">
          <div class="sidenav-logo-wrapper">
            <img class="sidenav-logo" alt="Shopliftr" src="/assets/images/logo-white-shopliftr.svg" />
          </div>
          <div class="sidenav-user-name">
            <mat-icon>person</mat-icon> <span>{{ userName$ | async }}</span>
          </div>
          <button mat-icon-button mgdButton [matMenuTriggerFor]="profileActions">
            <mat-icon>
              menu
            </mat-icon>
          </button>
          <mat-menu #profileActions="matMenu">
            <button mat-menu-item mgdButton (click)="onUpdatePasswordClick()">
              <mat-icon>lock_reset</mat-icon>
              <span>Update Password</span>
            </button>
            <button mat-menu-item mgdButton (click)="onLogoutClick()">
              <mat-icon>logout</mat-icon>
              <span>Logout</span>
            </button>
          </mat-menu>
        </div>
        <mat-divider></mat-divider>
        <mat-nav-list mgdProcessing>

          @for (link of sidenavLinks$ | async; track $index) {
            <a mat-list-item #rla="routerLinkActive" [activated]="rla.isActive"
            [matTooltip]="link.tooltip" matTooltipPosition="after" [routerLink]="link.commands" [info]="navigationSource"
            routerLinkActive="current-route">
            <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
            <span matLine>{{link.title}}</span>
          </a>
          }
        </mat-nav-list>
          @let appLinks = appLinks$ | async;
          @if (appLinks?.length) {
            <mat-divider></mat-divider>
            <mat-nav-list mgdProcessing>
            @for (link of appLinks; track $index) {
              <a mat-list-item  [matTooltip]="link.tooltip" matTooltipPosition="after" [href]="link.url" target="_blank" rel="noreferrer noopener">
                <mat-icon matListItemIcon>{{link.icon}}</mat-icon>
                <span matLine>{{link.title}}</span>
              </a>
            }
            </mat-nav-list>
          }
          <mat-divider></mat-divider>
        <mat-nav-list mgdProcessing>
          <a mat-list-item href="#" (click)="onRequestSupportClick($event)" matTooltip="Report a Problem"
            matTooltipPosition="after">
            <mat-icon matListItemIcon>contact_support</mat-icon>
            <span matLine>Report a Problem</span>
          </a>
        </mat-nav-list>
        <mat-divider></mat-divider>
        <div class="sidenav-version">
          version: {{ version }}
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="sidenav-router-outlet-wrapper">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>